import { useEffect } from "react";
import { useOrganizationService } from "../../services";
import { useJwt } from "../../helpers/common";
import { useNavigate } from "react-router-dom";

export function ResetOnBoarding() {

      const navigate = useNavigate();
      const { updateOrganization } = useOrganizationService();
      const JWTdata: any = useJwt();
      const org_id = JWTdata.org_id;


      const reset = async()=>{
           if (org_id && org_id !== "") {
          await updateOrganization(
               org_id,
               {
                 onboard_settings: {
                   // explore: true,
                   // pm_tools: {
                   //   jira: true,
                   //   asana: true,
                   //   azure: true,
                   //   slack: true,
                   //   github: true,
                   //   monday: true,
                   // },
                   // strategy_map: true,
                   // integrations: true,
                   // risk_mitigation: {
                   //   send: true,
                   //   analyze: true,
                   //   prefill: true,
                   //   awareness: true,
                   // },
                   // invite_people: true,
                   // org_skills:true
                 },
               },
               true,
             );
             navigate("/workitems");
           }
      }
      useEffect(() => {
        reset();
     
      }, [org_id]);
    return (
        <div>
        </div>
    )
}